document.addEventListener("DOMContentLoaded", () => {
  if (window.location.pathname !== "/") return; // Apply only on the home page

  const firstBanner = document.querySelector(
    "#Banner-template--16871981056099__image_banner_E9tFC3"
  );
  const secondBanner = document.querySelector(
    "#Banner-template--16871981056099__image_banner_6BRrRG"
  );

  let lastScroll = window.scrollY;

  if (firstBanner && secondBanner) {
    window.addEventListener("scroll", () => {
      const currentScroll = window.scrollY;

      // Trigger parallax effect on down scroll
      if (currentScroll > lastScroll) {
        firstBanner.classList.add("scrolled");
        secondBanner.classList.add("scrolled");
      } else {
        // Reset effect on up scroll
        firstBanner.classList.remove("scrolled");
        secondBanner.classList.remove("scrolled");
      }

      lastScroll = currentScroll;
    });
  }
});

// document.addEventListener("DOMContentLoaded", () => {
//   const curtainWrapper = document.querySelector(".curtain-wrapper");
//   if (!curtainWrapper) return;

//   window.addEventListener("scroll", () => {
//     const scrollPosition = window.scrollY + window.innerHeight;
//     const docHeight = document.documentElement.scrollHeight;

//     // Near bottom threshold
//     if (scrollPosition >= docHeight - 100) {
//       // Add the class, so content slides up
//       curtainWrapper.classList.add("curtain-up");
//     }
//     // Farther from bottom threshold
//     else if (scrollPosition < docHeight - 300) {
//       // Remove the class, so content slides back down
//       curtainWrapper.classList.remove("curtain-up");
//     }
//   });
// });

// document.addEventListener('DOMContentLoaded', () => {
//   const curtainWrapper = document.querySelector('.curtain-wrapper');
//   if (!curtainWrapper) return;

//   window.addEventListener('scroll', () => {
//     const scrollPosition = window.scrollY + window.innerHeight;
//     const docHeight = document.documentElement.scrollHeight;

//     // If user is near the bottom (100px threshold), slide the content up
//     if (scrollPosition >= docHeight - 100) {
//       curtainWrapper.classList.add('curtain-up');
//     } else {
//       // Remove the class if they scroll back up (optional).
//       // If you want the curtain to stay up once shown, omit this else block.
//       curtainWrapper.classList.remove('curtain-up');
//     }
//   });
// });

// FINAL VERSION
// document.addEventListener("DOMContentLoaded", () => {
//   const footerEl = document.querySelector(".footer");
//   if (!footerEl) return;

//   window.addEventListener("scroll", () => {
//     const scrollPosition = window.scrollY + window.innerHeight;
//     const docHeight = document.documentElement.scrollHeight;

//     // If user is within 100px of bottom, reveal the footer
//     if (scrollPosition >= docHeight - 100) {
//       footerEl.classList.add("footer--visible");
//     } else {
//       // If you want it to hide again when scrolling up:
//       footerEl.classList.remove("footer--visible");
//     }
//   });
// });

// GEMINI
// document.addEventListener('DOMContentLoaded', function() {
//   const footerElement = document.querySelector('.footer');

//   if (footerElement) {
//     function checkFooterVisibility() {
//       const windowHeight = window.innerHeight;
//       const documentHeight = document.documentElement.scrollHeight;
//       const scrollPosition = window.scrollY || window.pageYOffset;

//       if (scrollPosition + windowHeight >= documentHeight - 100) {
//         footerElement.classList.add('revealed');
//         window.removeEventListener('scroll', checkFooterVisibility);
//       }
//     }

//     window.addEventListener('scroll', checkFooterVisibility);
//     checkFooterVisibility();
//   }
// });

// for ok bttn on newsletter
document.addEventListener("DOMContentLoaded", () => {
  const emailInput = document.querySelector(
    '.newsletter-form__field-wrapper input[type="email"]'
  );
  const wrapper = document.querySelector(".newsletter-form__field-wrapper");

  if (emailInput && wrapper) {
    emailInput.addEventListener("click", () => {
      wrapper.classList.add("clicked"); // Show OK button on click
    });

    // Optional: hide the button when clicking outside
    document.addEventListener("click", (event) => {
      if (!wrapper.contains(event.target)) {
        wrapper.classList.remove("clicked"); // Hide button when clicking outside
      }
    });
  }
});

document.addEventListener("DOMContentLoaded", () => {
  const emailInput = document.querySelector(
    '.newsletter-form__field-wrapper input[type="email"]'
  );
  const wrapper = document.querySelector(".newsletter-form__field-wrapper");

  if (emailInput && wrapper) {
    emailInput.addEventListener("input", () => {
      if (emailInput.value.trim().length > 0) {
        wrapper.classList.add("has-text"); // Show OK button when typing
      } else {
        wrapper.classList.remove("has-text"); // Hide when empty
      }
    });
  }
});

document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    const socialList = document.querySelector(
      ".list-unstyled.list-social.footer__list-social"
    );
    const footerWrappers = document.querySelectorAll(
      ".footer__content-bottom-wrapper.page-width"
    );

    if (socialList && footerWrappers.length > 1) {
      const targetWrapper = footerWrappers[1];

      targetWrapper.appendChild(socialList);

      targetWrapper.style.display = "flex";
      targetWrapper.style.justifyContent = "space-between";
      targetWrapper.style.alignItems = "center";
      targetWrapper.style.flexWrap = "wrap";

      socialList.style.display = "flex";
      socialList.style.gap = "0em";
    }
  }, 100); // Adjust the delay if needed
});


// removes default drop down svgz fronm header menu
// document.addEventListener("DOMContentLoaded", function () {
//   document.querySelectorAll(".icon-caret").forEach(function (icon) {
//     icon.remove();
//   });
// });

// for read more toggle
document.addEventListener("DOMContentLoaded", function () {
  // Get <summary> and its parent <details>
  const summary = document.querySelector(
    "#Summary-collapsible_row_yLMD6B-template--16871981056099__collapsible_content_LeJfNa"
  );
  const details = summary?.closest("details");

  if (summary && details) {
    const readMoreWrapper = document.createElement("div");
    readMoreWrapper.textContent = "READ MORE...";
    readMoreWrapper.classList.add("read-more-line");
    summary.appendChild(readMoreWrapper);

    // Toggle event to change the text
    details.addEventListener("toggle", function () {
      const isOpen = details.hasAttribute("open");
      readMoreWrapper.textContent = isOpen ? "READ LESS..." : "READ MORE...";
      console.log("Toggle event:", isOpen ? "Opened" : "Closed");
    });
  } else {
    console.warn("Details or Summary element not found");
  }
});

// // footer z index change - for curtain effect
// function checkScrollPosition() {
//   const footer = document.querySelector("footer");
//   const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
//   const windowHeight = window.innerHeight;
//   const documentHeight = document.documentElement.scrollHeight;

//   if (scrollTop + windowHeight >= documentHeight) {
//     footer.style.zIndex = "1";
//   } else {
//     footer.style.zIndex = "-1";
//   }
// }

// window.addEventListener("scroll", checkScrollPosition);
// window.addEventListener("resize", checkScrollPosition); // for responsive adjustments
// document.addEventListener("DOMContentLoaded", checkScrollPosition);

//footer another approach instead of zindex

// document.addEventListener("DOMContentLoaded", function () {
//   const curtainWrapper = document.querySelector(".footer-curtain-wrapper");

//   if (!curtainWrapper) return;

//   const observer = new IntersectionObserver(
//     (entries) => {
//       entries.forEach((entry) => {
//         if (entry.isIntersecting) {
//           curtainWrapper.classList.add("in-view");
//         } else {
//           curtainWrapper.classList.remove("in-view");
//         }
//       });
//     },
//     {
//       threshold: 0.1,
//     }
//   );

//   observer.observe(curtainWrapper);
// });

// function checkScrollPosition() {
//   const footer = document.querySelector("footer");
//   const footerRect = footer.getBoundingClientRect();
//   const viewportHeight = window.innerHeight;

//   // If any part of the footer is visible in the viewport
//   if (footerRect.top < viewportHeight) {
//     footer.style.zIndex = "1";
//   } else {
//     footer.style.zIndex = "-1";
//   }
// }

// window.addEventListener("scroll", checkScrollPosition);
// window.addEventListener("resize", checkScrollPosition);
// document.addEventListener("DOMContentLoaded", checkScrollPosition);

// For menu alt attribute to be used for font change

document.addEventListener("DOMContentLoaded", () => {
  const menuSpans = document.querySelectorAll(".header__menu-item span");

  menuSpans.forEach((span) => {
    if (!span.dataset.altText) {
      span.setAttribute("data-alt-text", span.textContent.trim());
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".product__media img").forEach((img) => {
    img.style.transition = "transform 0.3s ease-in-out";

    img.addEventListener("mousemove", (e) => {
      const rect = img.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;

      img.style.transformOrigin = `${x}% ${y}%`;
      img.style.transform = "scale(2)"; /* Adjust zoom level */
    });

    img.addEventListener("mouseleave", () => {
      img.style.transform = "scale(1)";
      img.style.transformOrigin = "center";
    });
  });
});

// document.addEventListener("DOMContentLoaded", function () {
//   setTimeout(() => {
//     // Select all collapsible tabs
//     let collapsibleTabs = document.querySelectorAll("details");

//     if (collapsibleTabs.length > 0) {
//       // Open the first one
//       collapsibleTabs[0].setAttribute("open", "");

//       // Ensure aria-expanded is true for accessibility
//       let firstSummary = collapsibleTabs[0].querySelector("summary");
//       if (firstSummary) {
//         firstSummary.setAttribute("aria-expanded", "true");
//       }

//       // Close all other collapsible tabs
//       for (let i = 1; i < collapsibleTabs.length; i++) {
//         collapsibleTabs[i].removeAttribute("open");
//       }
//     }
//   }, 300); // Delay to prevent conflicts with other scripts
// });

// Select the main footer content container
// const footerContent = document.querySelector('.footer__content-top.page-width');

// // Proceed if the container exists
// if (footerContent) {
//   // Force select the columns inside
//   const columns = Array.from(footerContent.children);

//   if (columns.length > 0) {
//     // Create two wrapper divs: left (newsletter), right (others)
//     const leftDiv = document.createElement('div');
//     const rightDiv = document.createElement('div');

//     // Style them forcibly (you can refine later in CSS)
//     leftDiv.style.flex = '1';
//     rightDiv.style.flex = '2';
//     leftDiv.style.paddingRight = '20px'; // Add some spacing
//     rightDiv.style.display = 'flex';
  
//     // Move Newsletter (assuming it's the last column) into leftDiv
//     leftDiv.appendChild(columns[columns.length - 1]);

//     // Move other columns into rightDiv
//     columns.slice(0, columns.length - 1).forEach(col => {
//       rightDiv.appendChild(col);
//     });

//     // Clear old content
//     footerContent.innerHTML = '';
//     footerContent.style.display = 'flex';   // Make parent flex
//     footerContent.style.flexWrap = 'wrap';  // Allow wrapping on mobile
//     footerContent.appendChild(leftDiv);
//     footerContent.appendChild(rightDiv);
//   }
// }
